import create, { SetState } from 'zustand';

interface INavBarStore {
  blurred?: boolean;

  setBlurred(blurred: boolean): void;
}

export const [useNavBarStore, navBarStoreApi] = create<INavBarStore>((set: SetState<INavBarStore>) => ({
  blurred: false,
  setBlurred: (blurred: boolean) => set(() => ({ blurred })),
}));
